module.exports = __webpack_public_path__ + "static/media/arrow_up.ed13ca7a.svg";